module.exports = __webpack_public_path__ + "img/ep-T.72ebcaff.jpg";